import DynamicComponentBaseProps from "features/shared/components/dynamicComponetWrapper/DynamicComponentBaseProps";
import { useForm } from "features/shared/forms/hooks/useForm";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomerAccountRegistrationFormBaseProps from "./CustomerAccountRegistrationFormBaseProps";
import styles from "./customerAccountRegistrationForm.module.scss";
import FormGroup from "features/shared/forms/components/FormGroup";
import SelectInput from "features/shared/components/selectInput/SelectInput";
import OptionType from "features/shared/components/selectInput/OptionType";
import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import CustomerAccountRegistrationDTO from "features/registration/dtos/CustomerAccountRegistrationDTO";
import { getDataDescriptors } from "./customerAccountRegistrationFormHelper";
import CustomerAccountRegistrationFormBase from "./CustomerAccountRegistrationFormBase";
import EmailValidationRule from "features/validation/rules/EmailValidationRule";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loadDynamicFormConfig } from "features/shared/helpers/modules";

interface Props
  extends DynamicComponentBaseProps,
    CustomerAccountRegistrationFormBaseProps {}

const CustomerAccountRegistrationFormTeplarnyBrno = ({
  onSubmit,
  onBackClick,
  showAdditionalForm,
  additionalFormFields,
  setCustomFormFiedls
}: Props) => {
  // configuration
  const additionalFormFieldsEmobility = loadDynamicFormConfig("customerAccountRegistrationAdditionalForm.eMobility");

  // translations
  const tLabels = useTranslation("registration\\registration").t;
  const tCommodityDetails = useTranslation("contracts\\enums\\commodityDetail").t;
  const tTerms = useTranslation("shared\\terms").t;

  // state
  const [selectedAdditionFormFields, setSelectedAdditionFormFields] = useState(additionalFormFields);

  // form hook
  const formHandler =
    useForm({
      initialValidations: {
        Email: {
          required: true,
          type: "Email",
          message: "invalidEmail"
        } as EmailValidationRule,
        CommodityDetail: {
          required: true,
          type: "OnlyRequired",
        },
        ContractNumber: {
          required: true,
          type: "OnlyRequired",
        },
      },
    });

  const { values, errors, bindField, setValidationRule, valideteForm } = {...formHandler};

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (valideteForm()) {
      let registration: CustomerAccountRegistrationDTO = {}
      registration.registrationDescriptors = getDataDescriptors(values);

      if (values["CommodityDetail"] === CommodityDetail.eMobility) {
        setSelectedAdditionFormFields(additionalFormFieldsEmobility);
        
        if (setCustomFormFiedls) {
          setCustomFormFiedls([...additionalFormFieldsEmobility]);  
        }
      } else {
        setSelectedAdditionFormFields(additionalFormFields);
      }

      onSubmit(registration);
    }
  };

  // helpers
  const getTranslation = (name: string, type: "label" | "placeholder" | "tooltip") => { 
    return tLabels(`customerAccountRegistrationFormTeplarnyBrno.${name}.${type}`);
  }

  const getContractNumberTranslation = (type: "label" | "placeholder" | "tooltip") => { 
    if (values["CommodityDetail"] === CommodityDetail.HeatCustomer) {
      return tLabels(`customerAccountRegistrationFormTeplarnyBrno.ContractualAccountNumber.${type}`);
    } else {
      return tLabels(`customerAccountRegistrationFormTeplarnyBrno.ContractNumber.${type}`);
    }
  }

  // sub-renders
  const renderCommodityDetailSelect = () => {
    let commodityDetails: CommodityDetail[] = [
      CommodityDetail.ElectricityCustomer,
      CommodityDetail.GasCustomer,
      CommodityDetail.HeatCustomer,
      CommodityDetail.eMobility
    ];
    let options: OptionType[] = [];

    for (const item of commodityDetails) {
      options.push({
        value: item,
        name: tCommodityDetails(item),
      });
    }

    return (
      <SelectInput
        options={options}
        label={getTranslation("CommodityDetail", "label")}
        defaultValueLabel={getTranslation("CommodityDetail", "placeholder")}
        defaultValueLabelDisabled
        validationError={errors["CommodityDetail"]}
        {...bindField("CommodityDetail")}
      />
    );
  };

  const renderTooltipOpen = () => { 
    return (
      <span className="text-muted">
        <span className="mr-1">{tTerms("Help")}</span>
        <FontAwesomeIcon 
            icon={["far", "question-circle"]} 
            className="text-muted" 
          />
      </span>
    );
  }

  // render
  return (
    <div className={styles.formWrapper}>
      <form onSubmit={submitFormHandler}>
        <CustomerAccountRegistrationFormBase
          dynamicForm={{ formHandler: formHandler }}
          additionalFormFields={selectedAdditionFormFields}
          showAdditionalForm={showAdditionalForm}
          onSubmit={onSubmit}
          onBackClick={onBackClick}
        >
          <FormGroup
            labelText={getTranslation("Email", "label")}
            inputId="Email"
            validationError={errors["Email"]}
            tooltip={{
              id: "tooltip-Email",
              content: getTranslation("Email", "tooltip"),
              text: renderTooltipOpen,
              alignIconToRight: true
            }}
          >
            <input
              id="Email"
              className="form-control"
              placeholder={getTranslation("Email", "placeholder")}
              {...bindField("Email")}
            />
          </FormGroup>
          {renderCommodityDetailSelect()}
          <FormGroup
            labelText={getContractNumberTranslation("label")}
            inputId="ContractNumber"
            validationError={errors["ContractNumber"]}
            visible={values["CommodityDetail"] !== undefined}
            tooltip={{
              id: "tooltip-Email",
              content: getContractNumberTranslation("tooltip"),
              text: renderTooltipOpen,
              alignIconToRight: true,
            }}
          >
            <input
              id="ContractNumber"
              className="form-control"
              placeholder={getContractNumberTranslation("placeholder")}
              {...bindField("ContractNumber")}
            />
          </FormGroup>
        </CustomerAccountRegistrationFormBase>
      </form>
    </div>
  );
};

export default CustomerAccountRegistrationFormTeplarnyBrno;
